import { useEffect, useRef } from "react";
import { trackListingImpression } from "../lib/productImpressions";

export function useListingImpression(productId: string | undefined) {
  const ref = useRef<HTMLAnchorElement | null>(null);

  useEffect(() => {
    if (!productId) return;
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          trackListingImpression(productId);
          observer.disconnect();
        }
      },
      { threshold: 0.35 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [productId]);

  return ref;
}
